import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ListViewEvent, OverviewCard, OverviewCardActions } from '@iot-platform/models/common';
import { CardLoaderModule } from '../../card-loader/card-loader.module';
import { OverviewCardComponent } from '../../overview-card/overview-card.component';

@Component({
  selector: 'iot-platform-ui-list-view-content',
  imports: [FlexLayoutModule, OverviewCardComponent, CardLoaderModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './list-view-content.component.html'
})
export class ListViewContentComponent {
  loading = input<boolean>(false);
  card = input.required<OverviewCard>();
  dispatchEvent = output<ListViewEvent>();

  onDispatchCardEvent(action: OverviewCardActions): void {
    this.dispatchEvent.emit({ type: action });
  }
}
